export const ItemType_Tb = {
  type: 1,
  img: "https://www.taobao.com/favicon.ico",
  name: "淘宝",
  BaseItemUrl: "https://item.taobao.com/item.htm?id=_ITEMID_",
};
export const ItemType_Pdd = {
  type: 2,
  img: "https://p1.ssl.qhimg.com/dmsmfl/120_115_/t01466596de1a7b0e72.webp",
  name: "拼多多",
  BaseItemUrl: "https://mobile.yangkeduo.com/goods.html?goods_id=_ITEMID_",
};
export const ItemType_Jd = {
  type: 3,
  img: "https://pp.myapp.com/ma_icon/0/icon_7193_1602746729/96",
  name: "京东",
  BaseItemUrl: "https://item.jd.com/_ITEMID_.html",
};

export const ItemType_JdJx = {
  type: 3001,
  img: "https://img12.360buyimg.com/img/s120x120_jfs/t1/156232/8/3301/14468/5fec12ebEbfbe5e0e/7902e6f5a5f6fb92.png",
  name: "京喜",
  BaseItemUrl: "https://m.jingxi.com/item/view?sku=_ITEMID_",
};

export const ItemType_JdShop = {
  type: 3002,
  img: "https://porder.shop.jd.com/favicon.ico",
  name: "京东商家",
};
export const ItemType_XiaPi = {
  type: 4,
  img: "https://ph.xiapibuy.com/favicon.ico",
  name: "虾皮",
};
export const ItemType_Tb1688 = { type: 5, name: "1688", img: "https://www.1688.com/favicon.ico" };
export const ItemType_TouTiao = {
  type: 335,
  name: "1688",
  img: "http://lf1-cdn-tos.bytegoofy.com/goofy/ies/douyin_web/public/favicon.ico",
};

export const ItemType_SouKuan = {
  type: 203,
  img: "https://src.vvic.com/favicon.ico",
  name: "搜款网",
};
export const ItemType_571Xz = {
  type: 205,
  img: "https://www.571xz.com/favicon.ico",
  name: "四季星座网",
  BaseItemUrl: "https://www.571xz.com/item.htm?id=_ITEMID_",
};
export const ItemType_Wsy = {
  type: 206,
  img: "https://www.wsy.com/favicon.ico",
  name: "网商园",
};

export const ItemType_17Wsd = {
  type: 208,
  img: "https://aims.17zwd.com/favicon.ico",
  name: "17网",
};

export const ItemType_hznzcn = {
  type: 209,
  img: "http://img.hznzcn.com/favicon.ico",
  name: "杭州女装网",
};

export const ItemType_sooxie = {
  type: 210,
  img: "https://sooxie.com/favicon.ico",
  name: "爱搜鞋网",
};
export const ItemType_taoyang = {
  type: 213,
  img: "https://www.51taoyang.com/favicon.ico",
  name: "淘羊网",
};
export const ItemType_bao66 = {
  type: 214,
  img: "http://www.bao66.cn/favicon.ico",
  name: "包牛牛",
};
export const ItemType_pddPiFa = {
  type: 215,
  img: "https://img4.duote.com/duoteimg/zhushouimg/img/logo/705/83705/1213064540.png",
  name: "拼多多批发",
};
export const ItemType_xinkuan = {
  type: 204,
  img: "http://www.xingfujie.cn/favicon.ico",
  name: "新款网",
};

export const ItemType_qingchuang = {
  type: 216,
  img: "https://www.17qcc.com/favicon.ico",
  name: "青创网",
};

export const ItemType_tb1688Gj = {
  type: 217,
  img: `https://p.e5n.com/up/2016-4/20164271018458696.png`,
  name: "阿里巴巴国际站",
};

// {"value":17,"title":"阿里巴巴国际站","icon":zzb1688GjIcon},
//       {"value":18,"title":"托尼斯","icon":zzbTnsIcon},
export const ItemType_91jiafang = {
  type: 219,
  img: "http://www.91jf.com/favicon.ico",
  name: "91家纺网",
};

export const ItemType_chinaGoods = {
  type: 220,
  img: "https://www.chinagoods.com/favicon.ico",
  name: "义乌小商品城",
};

export const ItemType_K3 = {
  type: 221,
  img: "http://www.k3.cn/favicon.ico",
  name: "开山网",
};

export const ItemType_DuoShanWang = {
  type: 222,
  img: "https://www.ecduo.cn/static/images/index/favicon.ico?202104211906",
  name: "多商网",
};

export const ItemType_pddMms = {
  type: 300,
  img: "http://pp.myapp.com/ma_icon/0/icon_12181027_1637208383/96",
  name: "拼多多商家",
};

export const ItemType_sy3e3e = {
  type: 301,
  img: "http://www.3e3e.cn/images/favicon.ico",
  name: "生意网",
};

export const ItemType_mogu = {
  type: 302,
  img: "https://s10.mogucdn.com/mlcdn/c45406/170401_16fj5k6k4174bfd21d03a4gf6a7hg_48x48.png",
  name: "蘑菇街",
};

export const ItemType_wph = {
  type: 303,
  img: "https://category.vip.com/favicon.ico",
  name: "唯品会",
};

export const ItemType_eelly = {
  type: 304,
  img: "https://static.eelly.com/favicon.ico?20141229",
  name: "衣联网",
};

export const ItemType_amazon = {
  type: 305,
  img: "https://www.amazon.cn/favicon.ico",
  name: "亚马逊",
};

export const ItemType_jp0663 = {
  type: 306,
  img: "https://www.jp0663.com/assets/i/favicon.ico",
  name: "JP0663网",
};

export const ItemType_hanDanKu = {
  type: 307,
  img: "https://img3.duote.com/duoteimg/dtnew_softup_img/202103/447d915ecb370cc5.png",
  name: "好单库",
};

export const ItemType_Dataoke = {
  type: 308,
  img: "http://www.dataoke.com/favicon.ico",
  name: "大淘客",
};

export const ItemType_WeiPinHui = {
  type: 309,
  img: "https://detail.vip.com/favicon.ico",
  name: "唯品会",
};
export const ItemType_SuNing = {
  type: 310,
  img: "https://res.suning.cn/project/cmsWeb/suning/homepage/v8/css/images/float-bg.png?v=2020112301",
  name: "苏宁易购",
};

export const ItemType_lazada = {
  type: 311,
  img: "https://lazada-com.oss-ap-southeast-1.aliyuncs.com/static/image/new-lazada-logo-small.png",
  name: "lazada",
};

export const ItemType_zhe800 = {
  type: 312,
  img: "https://search.zhe800.com/favicon.ico",
  name: "折800",
};

export const ItemType_2Tong = {
  type: 313,
  img: "http://www.2tong.cn/favicon.ico",
  name: "二童网",
};

export const ItemType_kongfuzi = {
  type: 314,
  img: "http://search.kongfz.com/favicon.ico",
  name: "孔夫子旧书网",
};

export const ItemType_juyi5 = {
  type: 315,
  img: "http://src.onlinedown.net/images/h_iphone_imges/book_3/170926_1811168.jpg",
  name: "聚衣网",
};

export const ItemType_dhgate = {
  type: 316,
  img: "https://www.dhresource.com/favicon.ico",
  name: "敦煌网",
};

export const ItemType_madeInChina = {
  type: 317,
  img: "http://www.made-in-china.com/favicon.ico",
  name: "中国制造网",
};

export const ItemType_KuaiShou = {
  type: 318,
  img: "https://static.yximgs.com/s1/favicon.ico",
  name: "快手",
};

export const ItemType_JinBao = {
  type: 319,
  img: "https://pp.myapp.com/ma_icon/0/icon_53876027_1578498295/96",
  name: "多多进宝",
};

export const ItemType_aliexpress = {
  type: 320,
  img: "https://ae01.alicdn.com/images/eng/wholesale/icon/aliexpress.ico",
  name: "速卖通",
};

export const ItemType_zhaojiafang = {
  type: 321,
  img: "http://www.zhaojiafang.com/favicon.ico",
  name: "找家纺",
};
export const ItemType_tongshang = {
  type: 322,
  img: "https://www.5ts.com/favicon.ico",
  name: "童商网",
};
export const ItemType_e3hui = {
  type: 323,
  img: "http://www.e3hui.cn/favicon.ico",
  name: "衣衫汇",
};
export const ItemType_yunchepin = {
  type: 324,
  img: "http://www.rsdown.cn/d/file/p/2020-10-11/ab55a2e2e0e3a9c81716c3937ab3e599.png",
  name: "云车品",
};
export const ItemType_XiaPiSeller = {
  type: 325,
  img: "https://ph.xiapibuy.com/favicon.ico",
  name: "虾皮商家",
};

export const ItemType_lazadaSeller = {
  type: 326,
  img: "https://img.alicdn.com/imgextra/i4/O1CN0188kHoc1afYHhgTjQ6_!!6000000003357-55-tps-48-40.svg",
  name: "lazada商家",
};

// 添加 织里云仓
export const ItemType_zhiliyuncang = {
  type: 327,
  img: "https://www.yiyuen.com/e/file/view/289114",
  name: "织里云仓",
};

// 添加抖老板
export const ItemType_DouLaoBan = {
  type: 329,
  img: "https://static.doulaoban.com/www/favicon.ico",
  name: "抖老板",
};
// 添加 禅妈妈
export const ItemType_chanmama = {
  type: 330,
  img: "https://cdn-static.chanmama.com/sub-module/web/favicon.ico",
  name: "禅妈妈",
};
// 添加 精选联盟
export const ItemType_jingxuanlianmeng = {
  type: 331,
  img: "http://lf1-cdn-tos.bytegoofy.com/goofy/ies/douyin_web/public/favicon.ico",
  name: "精选联盟",
};
// 超级搜索
export const ItemType_dySuperSearch = {
  type: 332,
  img: "https://static.zzbtool.com/static/image/dy_super_search.jpg",
  name: "1688超级搜图",
  platform: "",
  platform_img: "http://lf1-cdn-tos.bytegoofy.com/goofy/ies/douyin_web/public/favicon.ico",
};

export const ItemType_PddSuperSearch = {
  type: 328,
  img: "https://zzbtool.com/static/zzb_search_icon3.jpg",
  name: "PDD超级搜图",
  platform: "拼多多",
  platform_img: "https://p1.ssl.qhimg.com/dmsmfl/120_115_/t01466596de1a7b0e72.webp",
};

// 视频下载
export const ItemType_dyVideo = {
  type: 333,
  name: "视频",
  img: "http://lf1-cdn-tos.bytegoofy.com/goofy/ies/douyin_web/public/favicon.ico",
};

//达人
export const ItemType_Daren = {
  type: 334,
  name: "达人号",
  img: "http://lf1-cdn-tos.bytegoofy.com/goofy/ies/douyin_web/public/favicon.ico",
};

export const ItemType_taote = {
  type: 6,
  img: "https://gw.alicdn.com/imgextra/i1/O1CN01GHHMBs1vm3vCJj1GP_!!6000000006214-2-tps-160-160.png",
  name: "淘特",
};

var allItemTypes = [
  ItemType_Tb,
  ItemType_Pdd,
  ItemType_Jd,
  ItemType_SouKuan,
  ItemType_571Xz,
  ItemType_Wsy,
  ItemType_17Wsd,
  ItemType_hznzcn,
  ItemType_Tb1688,
  ItemType_sooxie,
  ItemType_taoyang,
  ItemType_bao66,
  ItemType_xinkuan,
  ItemType_qingchuang,
  ItemType_91jiafang,
  ItemType_tb1688Gj,
  ItemType_JdJx,
  ItemType_chinaGoods,
  ItemType_pddPiFa,
  ItemType_pddMms,
  ItemType_K3,
  ItemType_sy3e3e,
  ItemType_mogu,
  ItemType_XiaPiSeller,
  ItemType_XiaPi,
  ItemType_wph,
  ItemType_eelly,
  ItemType_amazon,
  ItemType_jp0663,
  ItemType_JdShop,
  ItemType_hanDanKu,
  ItemType_Dataoke,
  ItemType_WeiPinHui,
  ItemType_lazada,
  ItemType_SuNing,
  ItemType_zhe800,
  ItemType_2Tong,
  ItemType_kongfuzi,
  ItemType_juyi5,
  ItemType_dhgate,
  ItemType_DuoShanWang,
  ItemType_lazadaSeller,
  ItemType_madeInChina,
  ItemType_KuaiShou,
  ItemType_JinBao,
  ItemType_aliexpress,
  ItemType_zhaojiafang,
  ItemType_tongshang,
  ItemType_e3hui,
  ItemType_yunchepin,
  ItemType_TouTiao,
  ItemType_zhiliyuncang,
  ItemType_jingxuanlianmeng,
  ItemType_DouLaoBan,
  ItemType_chanmama,
  ItemType_PddSuperSearch,
  ItemType_dySuperSearch,
  ItemType_dyVideo,
  ItemType_Daren,
  ItemType_taote,
];

export const CateType_Zhutu = { type: 1, name: "主图" };
export const CateType_SKU = { type: 2, name: "SKU" };
export const CateType_Detail = { type: 3, name: "详情图" };
export const CateType_Video = { type: 4, name: "视频" };
export const CateType_Comment = { type: 5, name: "评价图" }; // 用于大淘客
export var allCateTypes = [CateType_Zhutu, CateType_SKU, CateType_Detail, CateType_Video, CateType_Comment];

export const FileType_Img = { type: 1 };
export const FileType_Video = { type: 2 };
export const FileType_Txt = { type: 0 };
export const FileType_Excel = { type: 3 };
export const FileType_Csv = { type: 4 };

export const Zzb_One_Order = {
  appType: 1,
  AppName: "至尊宝一键打单",
  platformType: ItemType_pddMms.type,
  platformName: "拼多多",
  loginUrl: "https://mms.pinduoduo.com",
};
export const Zzb_Super_Goods = {
  appType: 2,
  AppName: "至尊宝超级上货",
  platformType: ItemType_pddMms.type,
  platformName: "拼多多",
  loginUrl: "https://mms.pinduoduo.com",
};
//export const Xf_One_order = {appType: 3,AppName: '晓风一键打单',platformType: ItemType_pddMms.type,platformName: '拼多多',loginUrl: 'https://mms.pinduoduo.com'}
// export const Xf_Super_Goods = {appType: 4,AppName: '晓风商品',platformType: ItemType_pddMms.type,platformName: '拼多多',loginUrl: 'https://mms.pinduoduo.com'}
export const Zf_One_order = {
  appType: 5,
  AppName: "紫风一键打单",
  platformType: ItemType_pddMms.type,
  platformName: "拼多多",
  loginUrl: "https://mms.pinduoduo.com",
};
export const Zf_Super_Goods = {
  appType: 6,
  AppName: "紫风超级上货",
  platformType: ItemType_pddMms.type,
  platformName: "拼多多",
  loginUrl: "https://mms.pinduoduo.com",
};
export const Dy_Super_Goods = {
  appType: 7,
  AppName: "至尊宝超级商品",
  platformType: ItemType_TouTiao.type,
  platformName: "",
  loginUrl: "https://fxg.jinritemai.com",
};
export const Dy_one_Order = {
  appType: 8,
  AppName: "至尊宝一键打单",
  platformType: ItemType_TouTiao.type,
  platformName: "",
  loginUrl: "https://fxg.jinritemai.com",
};
export const Ks_Super_Goods = {
  appType: 9,
  AppName: "至尊宝超级商品",
  platformType: ItemType_KuaiShou.type,
  platformName: "快手",
  loginUrl: "https://www.kwaishop.com/",
};
export const Tb1688_Super_Goods = {
  appType: 10,
  AppName: "至尊宝超级商品",
  platformType: ItemType_Tb1688.type,
  platformName: "1688",
  loginUrl: "https://login.1688.com/member/jump.htm",
};
export const Tb1688_Super_Order = {
  appType: 11,
  AppName: "至尊宝订单",
  platformType: ItemType_Tb1688.type,
  platformName: "1688",
  loginUrl: "https://login.1688.com/member/jump.htm",
};
export const JD_through_Train = {
  appType: 12,
  AppName: "至尊宝直通车",
  platformType: ItemType_Jd.type,
  platformName: "京东",
  loginUrl: "https://jzt.jd.com/gw/?ReturnUrl=https%3A%2F%2Fjzt.jd.com%2Fjdkc%2Fsurvey.html#/normal_v3/list",
};
//至尊宝达人转链
export const Dy_Daren_Platform = {
  appType: 13,
  AppName: "至尊宝达人转链",
  platformType: ItemType_Daren.type,
  platformName: "",
  loginUrl: "https://buyin.jinritemai.com/mpa/account/login?log_out=1&type=24",
};
//淘宝直通车
export const TB_through_Train = {
  appType: 14,
  AppName: "至尊宝直通车",
  platformType: ItemType_Tb.type,
  platformName: "淘宝",
  loginUrl: "https://subway.simba.taobao.com/indexnew.jsp",
};

// https://loginmyseller.taobao.com/?from=&f=top&style=&sub=true&redirect_url=https%3A%2F%2Fmyseller.taobao.com%2Fhome.htm%2FQnworkbenchHome%2F  login千牛
// https://subway.simba.taobao.com/indexnew.jsp  直通车

export const AppIdList = [
  Zzb_One_Order,
  Zzb_Super_Goods,
  //Xf_One_order,
  // Xf_Super_Goods,
  Zf_One_order,
  Zf_Super_Goods,
  Dy_Super_Goods,
  Dy_one_Order,
  Ks_Super_Goods,
  Tb1688_Super_Goods,
  Tb1688_Super_Order,
  JD_through_Train,
  Dy_Daren_Platform,
  TB_through_Train,
];

export function GetItemType(type) {
  var info = null;
  allItemTypes.map((item) => {
    if (item.type == type) info = item;
  });
  return info;
}

export function GetItemByName(name) {
  var info = null;
  allItemTypes.map((item) => {
    if (item.name == name) info = item;
  });
  return info;
}

export function GetCateType(type) {
  if (type == -1) return {};
  var info = null;
  allCateTypes.map((item) => {
    if (item.type == type) info = item;
  });
  return info;
}
